import { PostalCodesRepository } from '@packlink/packlink-sdk';
import Packlink from '@sdk';
const postalCodesRepository = new PostalCodesRepository(Packlink.apiClient);

export const postalCodesRequestCache = new Map<string, Promise<boolean>>();

const isValidZipCode = async (alpha2Code: string, zipCode: string): Promise<boolean> => {
    try {
        const postalCodes = await postalCodesRepository.allByAlpha2Code(alpha2Code, { q: zipCode });
        return postalCodes.length > 0;
    } catch {
        return true;
    }
};

export const isZipCodePresent = (alpha2Code: string, zipCode: string): Promise<boolean> => {
    const id = `${alpha2Code}-${zipCode}`;

    if (postalCodesRequestCache.has(id)) {
        return postalCodesRequestCache.get(id) || Promise.resolve(false);
    }
    const result = isValidZipCode(alpha2Code, zipCode);
    postalCodesRequestCache.set(id, result);
    return result;
};
